import type { ReactNode } from 'react';
import Icon from './Icon';
import Expander from './Expander';

/**
 * ONE ROW OF THE PLAN'S "GETTING STARTED" GROUP — the shared head for both guidance
 * panels (Lessons worth carrying in + How to set up & run this project), built on the
 * Plan's own disclosure grammar (chevron · title · peek · count), so the two helpers
 * read as one family with the plan sections beneath them rather than as a floating
 * card bolted on top (Vinnie, 21 Oct 2026).
 *
 * The whole head is the toggle — there is no separate "Show"/"Hide" control; the
 * collapsed one-line row IS the dismissed state, remembered per viewer by the owning
 * component, so folding it away stays fully reversible. The peek (a one-line summary)
 * shows only while collapsed; the count chip shows in both states.
 */
export default function GuidanceRow({
  title,
  peek,
  count,
  open,
  onToggle,
  children,
}: {
  title: string;
  peek: string;
  count: ReactNode;
  open: boolean;
  onToggle: () => void;
  children: ReactNode;
}) {
  return (
    <div className={`gg-row${open ? ' is-open' : ''}`}>
      <button type="button" className="gg-head" aria-expanded={open} onClick={onToggle}>
        <span className="gg-chev">
          <Icon name="chevron" size={18} />
        </span>
        <span className="gg-title">{title}</span>
        {!open && <span className="gg-peek">{peek}</span>}
        <span className="gg-count">{count}</span>
      </button>
      {/* Opens and closes on the shared Expander — the same measured-height slide
          the Plan sections, the metrics strip and the card panels use — so the
          guidance folds smoothly rather than snapping (Vinnie, 25 Oct). */}
      <Expander open={open}>
        <div className="gg-body">{children}</div>
      </Expander>
    </div>
  );
}
